import React from 'react';
import PropTypes from "prop-types";
import "./WrapperInputGroup.css";
import {AlertBar} from "../../alert/Alerts";

export default function WrapperInputGroup(WrappedComponent, parentProps) {
    return class extends React.Component {
        constructor(props) {
            super(props);
            this.handleChange = this.handleChange.bind(this);
            this.handleBlur = this.handleBlur.bind(this);
            this.handleAlert = this.handleAlert.bind(this);
            this.handleFocus = this.handleFocus.bind(this);
            this.state = {
                label: {
                    class: props.input.label.class,
                    name: props.input.label.name
                }
            };
        }

        componentWillMount() {
            this.handleAlert();
            let state = Object.assign(this.state);
            state.label.class = this.props.input.value && parentProps && !parentProps.isCheckbox ? "small" : "";
            this.setState(state);
        }

        componentWillReceiveProps(nextProps) {
            let state = Object.assign(this.state);
            state.label.class = this.props.input.value && parentProps && !parentProps.isCheckbox ? "small" : "";
            this.setState(state);
            this.handleAlert(nextProps);
        }

        handleAlert(nextProps) {
            let wrapper = "input-group";
            if(nextProps && nextProps.alert !== this.props.alert && nextProps.alert && nextProps.alert.show) {
                switch (nextProps.alert.type) {
                    case "error":
                        wrapper = "input-group input-error";
                        break;
                    case "warning":
                        wrapper = "input-group input-warning";
                        break;
                    case "info":
                        wrapper = "input-group input-info";
                        break;
                    case "success":
                        wrapper = "input-group input-success";
                        break;
                    default:
                        wrapper = "input-group";
                        break;
                }
            }
            let state = Object.assign(this.state);
            state.wrapper = wrapper;
            this.setState(state);
        }

        handleChange(e) {
            if(parentProps && parentProps.isCheckbox) {
                this.props.onChange(e.target !== undefined ? e.target.checked : e);
            } else {
                this.props.onChange(e.target !== undefined ? e.target.value : e);
            }

        }
        handleBlur(e) {
            let val;
            if(parentProps && parentProps.isCheckbox) {
                val = e.target !== undefined ? e.target.checked : e;
            } else {
                val = e.target !== undefined ? e.target.value : e;
            }
            this.props.onBlur(val);
            let state = Object.assign(this.state);
            state.label.class = val && parentProps && !parentProps.isCheckbox ? "small" : "";
            this.setState(state);
        }

        handleFocus(e) {
            let state = Object.assign(this.state);
            state.label.class = parentProps && !parentProps.isCheckbox ? "small" : "";
            this.setState(state);
        }

        render() {
            return (
                <div className="input-field">
                    <div className={this.state.wrapper}>
                        <WrappedComponent {...this.props} onChange={this.handleChange} onBlur={this.handleBlur} onFocus={this.handleFocus}/>
                        <label htmlFor={this.props.input.id}
                               className={this.state.label.class}>{this.state.label.name}</label>
                    </div>
                    <AlertBar alert={this.props.alert} onClick={this.props.onClick}/>
                </div>

            )
        }
    }
}

WrapperInputGroup.propTypes = {
    input: PropTypes.shape({
        label: PropTypes.object.isRequired,
    }).isRequired,
    alert: PropTypes.shape({
        show: PropTypes.bool.isRequired,
        title: PropTypes.string,
        text: PropTypes.string,
        type: PropTypes.string,
        dismissible: PropTypes.bool,
    }),
    onChange: PropTypes.func.isRequired,
    onBlur: PropTypes.func,
    onFocus: PropTypes.func,
    onClick: PropTypes.func
};


// WEBPACK FOOTER //
// ./src/input/base/WrapperInputGroup.js